
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/gateway",
      function () {
        return require("private-next-pages/pam/gateway.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/gateway"])
      });
    }
  